import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES = {
  '/': 'Tent Finder — Not By Chance Inc.',
  '/help': 'Volunteer / Offer Help — Tent Finder',
  '/get-help': 'Get Help — Tent Finder',
  '/report-camp': 'Report Camp — Tent Finder',
  '/donate': 'Donate — Tent Finder',
  '/privacy': 'Privacy Policy — Tent Finder',
  '/login': 'Admin Login — Tent Finder',
  '/admin/login': 'Admin Login — Tent Finder',
  '/admin': 'Admin Dashboard — Tent Finder',
};

/**
 * Scrolls to top, sets document title, and moves focus to main content on route change.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = PAGE_TITLES[pathname] || 'Tent Finder — Not By Chance Inc.';
    const main = document.getElementById('main-content');
    if (main) {
      if (!main.hasAttribute('tabindex')) {
        main.setAttribute('tabindex', '-1');
      }
      // Avoid stealing focus on first paint when user is still on the initial route
      if (document.activeElement && document.activeElement !== document.body) {
        main.focus({ preventScroll: true });
      }
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
